/** Games list / select-game: whether fans should enter the normal flow vs pre-moment signup. */
export function gameHasPublishedMoments(game: {
  publishedPhotosCount?: number;
  lastMomentTeam1Score?: number | null;
} | null | undefined): boolean {
  if (!game) return false;
  if ((game.publishedPhotosCount ?? 0) > 0) return true;
  return game.lastMomentTeam1Score != null;
}
